const propet80 = () => {
   return (
      <p>
         SonoScape ProPet 80 – стационарная модель новейшей серии ветеринарных ультразвуковых систем SonoScape с превосходным уровнем визуализации и функционалом, специализированным ПО и детально проработанной эргономикой. Линейка ProPet полностью отвечает всем современным требованиям ветеринарных специалистов.<br /><br />
         <strong>Технические характеристики</strong><br />
         Большой ЖК-монитор с диагональю 21,5”<br />
         Сенсорная панель управления с диагональю 13,3”<br />
         5 активных портов для подключения датчиков<br />
         Диапазон рабочих частот: 1-17 МГц<br />
         Регулируемая панель управления по высоте и по углу<br />       
      </p>
   );
}

export default propet80;